{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Chrome ekstenzija nije instalirana.",
      "CTA": "Instaliraj ekstenziju"
    },
    "TABS": {
      "PHONE": "Telefon",
      "SMS": "SMS",
      "HISTORY": "Istorija"
    },
    "HISTORY": {
      "OPEN": "Otvoreni",
      "RECENT": "Nedavni",
      "MISSED": "Propušteni",
      "LOADING": "Učitavanje poziva...",
      "EMPTY": "Nema poziva",
      "ERROR": "Pozive nije bilo moguće učitati",
      "CALL": "Pozovi nazad",
      "CALL_STATUS": {
        "BUTTON": "Postavi status poziva",
        "TITLE": "Status poziva",
        "SEARCH_PLACEHOLDER": "Pretraži statuse...",
        "LOADING": "Učitavanje statusa...",
        "NO_OPTIONS": "Nijedan status poziva nije podešen",
        "NO_MATCH": "Nema statusa koji odgovara",
        "OPTIONS_ERROR": "Statuse nije bilo moguće učitati",
        "RETRY": "Pokušaj ponovo",
        "CONFIRM_QUESTION": "Postaviti „{status}” i rešiti razgovor?",
        "CONFIRM": "Potvrdi",
        "BACK": "Nazad",
        "CANCEL": "Otkaži",
        "SAVING": "Čuvanje...",
        "SAVE_ERROR": "Status nije bilo moguće sačuvati",
        "RESOLVE_ERROR": "Status je sačuvan, ali razgovor nije bilo moguće rešiti"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Broj telefona, npr. +421903000000",
      "BODY_PLACEHOLDER": "Napišite poruku...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Pošalji SMS",
      "SENDING": "Slanje...",
      "SENT": "SMS poslat",
      "LOADING": "Učitavanje SMS sandučića...",
      "NO_INBOX": "Ovaj nalog nema SMS sandučić pa SMS ne može biti poslat.",
      "INVALID_NUMBER": "Unesite broj u međunarodnom formatu, uključujući početno +.",
      "ERROR": "SMS nije poslat. Pokušajte ponovo."
    },
    "ACTIONS": {
      "CONNECT": "Poveži se",
      "GO_TO_TAB": "Idi na tu karticu",
      "DISCONNECT": "Prekini vezu",
      "ANSWER": "Odgovori",
      "HANGUP": "Prekini poziv",
      "HOLD": "Zadrži",
      "MUTE": "Isključi mikrofon",
      "SILENCE": "Isključi zvuk",
      "TRANSFER": "Prebaci",
      "COMPLETE_TRANSFER": "Završi prebacivanje",
      "RETURN_TO_CALLER": "Vrati se pozivaocu",
      "CANCEL_TRANSFER": "Otkaži prebacivanje",
      "DIALPAD": "Prikaži tastaturu",
      "OPEN_CONVERSATION": "Otvori razgovor"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Dolazni poziv",
      "INCOMING_CALL_FROM": "Dolazni poziv od {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Dolazni poziv sa broja {number}",
      "ANSWER": "Odgovori",
      "DECLINE": "Odbij"
    },
    "TRANSFER": {
      "TITLE": "Prebacivanje poziva",
      "PLACEHOLDER": "Unesite broj za prebacivanje...",
      "SEARCH_PLACEHOLDER": "Pretraži agente...",
      "TARGET_PLACEHOLDER": "Izabrani primalac prebacivanja",
      "CONFIRM": "Prebaci",
      "MODE_DIRECT": "Prebaci odmah",
      "MODE_CONSULT": "Prvo pozovi agenta",
      "CANCEL": "Otkaži"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Da li ste sigurni da želite da odete na pauzu za sve redove?",
      "CONFIRM_READY": "Da li ste sigurni da želite da se vratite u status spremnosti za sve redove?",
      "CONFIRM_BREAK_QUEUE": "Da li ste sigurni da želite da se odjavite iz reda {queue}?",
      "CONFIRM_READY_QUEUE": "Da li ste sigurni da želite da se prijavite u red {queue}?",
      "LOGIN_TO_QUEUE": "Prijavi se",
      "LOGOUT_FROM_QUEUE": "Odjavi se",
      "LOGIN_TO_ALL_QUEUES": "Prijavi se u sve redove",
      "LOGOUT_FROM_ALL_QUEUES": "Odjavi se iz svih redova",
      "OPTION_LOGOUT": "Odjavi se",
      "OPTION_BREAK": "Pauza",
      "OPTION_LUNCH": "Ručak",
      "OPTION_AWAY": "Odsutan",
      "OPTION_DO_NOT_DISTURB": "Ne uznemiravaj",
      "OPTION_BUSINESS_TRIP": "Službeni put",
      "CONFIRM": "Potvrdi",
      "CANCEL": "Otkaži"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Nema veze sa telefonskim sistemom",
      "MESSAGE": "Izgleda da vaša internet veza ne radi. Proverite je i pokušajte ponovo.",
      "CREDENTIALS_TITLE": "Telefonski sistem je odbio vaše kredencijale",
      "CREDENTIALS_MESSAGE": "Telefonski sistem je odbio korisničko ime ili lozinku koje ste sačuvali u svom profilu. Proverite ih u Podešavanjima profila ili se obratite administratoru.",
      "CONFIGURATION_TITLE": "Podešavanja telefona nisu ispravna",
      "CONFIGURATION_MESSAGE": "SIP korisničko ime ili adresa servera nisu u ispravnom formatu, pa telefon ne može da se poveže. Ispravite to u Podešavanjima profila.",
      "NETWORK_SHORT": "Veza nije uspela",
      "CREDENTIALS_SHORT": "Kredencijali odbijeni",
      "CONFIGURATION_SHORT": "Nevažeća podešavanja telefona",
      "RETRY": "Pokušaj ponovo",
      "DISMISS": "Otkaži"
    },
    "CONNECTION_QUALITY": "Kvalitet veze",
    "CONNECTION_QUALITY_EXCELLENT": "Odlično",
    "CONNECTION_QUALITY_GOOD": "Dobro",
    "CONNECTION_QUALITY_FAIR": "Osrednje",
    "CONNECTION_QUALITY_POOR": "Loše",
    "CONNECTION_QUALITY_DISCONNECTED": "Veza prekinuta",
    "STATUS": {
      "OFFLINE": "Telefon offline",
      "IN_OTHER_TAB": "Telefon je povezan na drugoj kartici",
      "CONNECTING": "Povezivanje...",
      "DISCONNECTING": "Prekidanje veze...",
      "ONLINE": "Telefon online",
      "DIALING": "Pozivanje",
      "TRANSFERRING": "Prebacivanje poziva...",
      "CONSULTING": "Razgovor sa agentom",
      "CALLER_ON_HOLD": "Pozivalac je na čekanju",
      "BUSY": "Zauzeto",
      "DND": "DND",
      "UNAVAILABLE": "Nedostupno",
      "REJECTED": "Poziv odbijen",
      "CALL_FAILED": "Poziv nije uspeo"
    },
    "QUEUES": {
      "MORE": "Ostali redovi"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "Pozivanje {number}… Možete zatvoriti ovu karticu.",
    "NO_NUMBER": "Broj nije naveden. Koristite ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Unesite broj telefona...",
    "ACTIONS": {
      "DIAL": "Pozovi broj",
      "DIAL_FROM": "Izaberite broj sa kog zovete"
    },
    "DIAL_FROM": {
      "TITLE": "Poziv sa broja sandučeta"
    },
    "VALIDATION": {
      "REQUIRED": "Broj telefona je obavezan",
      "INVALID_FORMAT": "Nevažeći format broja telefona"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Audio podešavanja i testiranje",
    "SELECT_DEVICE": "Izaberite uređaj...",
    "SYSTEM_DEFAULT": "Podrazumevani sistemski uređaj",
    "SAVED": "Sačuvano",
    "DISCONNECTED_SUFFIX": "nije povezan",
    "DEVICE_DISCONNECTED": "Izabrani uređaj nije povezan. Pozivi koriste podrazumevani sistemski uređaj dok se ponovo ne poveže.",
    "MICROPHONE": {
      "TITLE": "Mikrofon",
      "START_TEST": "Testiraj mikrofon",
      "STOP_TEST": "Zaustavi test",
      "LEVEL": "Nivo:",
      "VERDICT": {
        "LISTENING": "Recite nešto u mikrofon…",
        "SILENT": "Ne čuju vas. Proverite da li je mikrofon uključen i da li je izabran pravi.",
        "LOW": "Čuju vas samo tiho. Izaberite drugi mikrofon ili podesite ulaznu jačinu u sistemskim podešavanjima.",
        "GOOD": "Dobar zvuk — dobro vas čuju."
      }
    },
    "SPEAKER": {
      "TITLE": "Zvučnik",
      "TEST": "Testiraj zvučnik",
      "TESTING": "Testiranje...",
      "VOLUME": "Jačina zvuka:",
      "USING_DEFAULT": "Izabrani izlaz nije dostupan — pušteno preko podrazumevanog sistemskog uređaja."
    },
    "DONE": "Gotovo",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Greška pri pristupu mikrofonu. Proverite dozvole.",
      "MICROPHONE_PERMISSION_DENIED": "Pristup mikrofonu je blokiran. Dozvolite ga u podešavanjima sajta u pregledaču da biste mogli da koristite telefon.",
      "MICROPHONE_SILENT": "Vaš mikrofon ne registruje zvuk. Proverite podešavanja zvuka.",
      "EXTENSION_REQUIRED": "Telefonska ekstenzija nije pronađena. Instalirajte je ili je omogućite da biste koristili mikrofon.",
      "SPEAKER_TEST": "Greška pri testiranju zvučnika."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "BUSY": "Zauzeto"
  },
  "QUEUE_STATUS": {
    "READY": "Spreman",
    "NOT_READY": "Ne prima pozive",
    "WRAP_UP": "Obrada poziva",
    "BREAK": "Pauza",
    "LUNCH": "Ručak",
    "AWAY": "Odsutan",
    "DO_NOT_DISTURB": "Ne uznemiravaj",
    "BUSINESS_TRIP": "Službeni put",
    "OTHER_CALL": "Drugi poziv",
    "QUEUE_CALL": "Poziv iz reda",
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "NO_ACCESS": "Nema telefona",
    "PARTIALLY_READY": "Delimično spreman",
    "MIXED": "Mešovito",
    "CHAT_ONLINE": "Online (chat)",
    "CHAT_BUSY": "Zauzeto (chat)",
    "CHAT_OFFLINE": "Offline (chat)"
  }
}
